import React, { useEffect } from 'react';
import CoreTable from 'components/Core/Table';
import { STLogo } from 'components/Brand/Logos/STLogo';
import { STIcon } from 'components/Brand/Icons/STIcon';
import Text from 'components/Core/Text';

import { TableContainer, TableWrapper } from './styles';

const Table = ({ zebra, columns, margin, tableData, title, ...otherProps }) => {
  const hasServiceTitanColumn = columns?.some((column) => column.serviceTitanColumn);
  useEffect(() => {
    document.querySelectorAll('.table--serviceTitanColumn-cell').forEach((targetElement) => {
      let previousElement = targetElement.previousElementSibling;

      while (previousElement?.tagName === 'TD') {
        previousElement.style.borderRight = 'none';
        previousElement = previousElement.previousElementSibling;
      }
    });
  }, []);

  const updatedColumns = columns?.map(({ ...column }) => {
    if (column.serviceTitanColumn) {
      column.title = (
        <>
          <span className="table--st-logo">
            <STLogo className="desktop-logo" />
            <STIcon type="st-glyph" className="mobile-logo" />
          </span>
        </>
      );
      column.className = 'table--serviceTitanColumn-cell';
    } else {
      column.title = (
        <>
          <Text type="h6" size="h5" color="white" marginMobile="0">
            {column.title}
          </Text>
        </>
      );
    }
    return column;
  });

  const updatedTableData = () => {
    let counter = 0;

    return tableData?.map(({ ...data }, index) => {
      data.key = index;

      Object.keys(data).forEach((column) => {
        if (data[column] === '✓' || data[column] === 'tick')
          data[column] = <STIcon type="icon-table-tick" />;
        if (data[column] === 'X' || data[column] === 'untick')
          data[column] = <STIcon type="icon-table-untick" />;
      });

      if (zebra) {
        if (data.subhead) {
          counter = 0;
        } else {
          if (counter % 2 !== 0) {
            data.zebra = true;
          }
          counter += 1;
        }
      }

      return data;
    });
  };

  return (
    <TableContainer>
      {title && <h2>{title}</h2>}
      <TableWrapper margin={margin}>
        <CoreTable
          hasServiceTitanColumn={hasServiceTitanColumn}
          columns={updatedColumns}
          dataSource={updatedTableData()}
          pagination={false}
          className={hasServiceTitanColumn ? 'st-table' : 'base-table'}
          {...otherProps}
        />
      </TableWrapper>
    </TableContainer>
  );
};

export default Table;
